export const FollowRouting = [
  {
    path: "/project/follow/list",
    name: "project-follow-list",
    meta: { title: "项目跟进" },
    component: () =>
      import(/* webpackChunkName: "project-follow" */ "@/views/project/follow/list/index.vue"),
  },
  {
    hidden: true,
    path: "/project/follow/create",
    name: "project-follow-create",
    meta: { title: "添加项目跟进记录",comName:"ProjectFollowFormCreate" },
    component: () =>
      import(/* webpackChunkName: "project-follow" */ "@/views/project/follow/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/project/follow/detail/:id",
    name: "project-follow-detail",
    meta: { title: "项目跟进详情" },
    component: () =>
      import(/* webpackChunkName: "project-follow" */ "@/views/project/follow/detail/index.vue"),
  },
];
